import { DropDownMenuAPI, FetchAPI, PanelAPI, PDFViewerAPI, InformationBarAPI, ActionAPI } from '@philips-internal/oswald-ui-components';
import Controller, { OnAfterFetch, OnClick, OnCollapse, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { ClickEvent, FetchEvent, MountEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import moment from 'moment/moment.js';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services/message-service';
import { Inject } from '@odinjs/odin';
import { APPLICATION_ENDPOINTS } from '../../constants/application-endpoints';
import PacsLinkGeneratorService from '../../services/pacs-link-generator-service';
import ReportService from '../../services/report-service';
import BaseControllerExams from '../BaseControllerExams';
import { Data } from './../../interfaces/data';
import './exam-details-controller.css';
import { ISO_DATE_FORMAT } from '@philips-internal/oswald-ui-model/lib/formatters/date/date-utils';
import { CardExamEstablishmentInformationAPI } from '@philips-emr/referring-physician-components/lib';
import { CardExamsTitleAPI } from '@philips-emr/referring-physician-components/lib';
import { APPLICATION_ROUTES } from '../../constants/application-routes';
import { wrapImageBase64 } from '../../utils/wrapImageBase64';
import { isMobile } from '@philips-internal/oswald-ui-utils';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';
import { Person } from '../../interfaces/Person';
import ToastService from '../../services/toast-service';
import { ExamDetailsAliases } from '../../codegen';

interface ExamDetail {
  nrSequencia: string;
  nrSequenciaProced: string;
  status: string;
  internSequenceNumber: string;
  nmExame: string;
  nrPrescricao: string;
  dtProcedimento: string;
  nmPessoaFisica: string;
  type: string;
  ieLido: string;
  nrAcessoDicom: string;
  cdEstabelecimento: string;
  ieFormato: string;
  nrSeqExame: string;
  sequencePrescription: string;
}

@Controller({ fragment: 'exam-details', component: 'layout-exam-details' })
class ExamDetails extends BaseControllerExams {

  @Inject('fetch-exam-details')
  fetchExamDetails: FetchAPI

  @Inject('pdf-viewer-exam-details')
  pdfViewer: PDFViewerAPI

  @Inject('card-exams-establishment-information-0')
  cardEstablishment: CardExamEstablishmentInformationAPI;

  @Inject('fetch-exams')
  filterList: FetchAPI;

  @Inject('panel-exam-card')
  panelDetails: PanelAPI;

  @Inject('panel-loader')
  panelLoader: PanelAPI;

  @Inject('panel-message')
  panelReportError: PanelAPI;

  @Inject('drop-down-menu-send-mail')
  dropDownMenuSendMail: DropDownMenuAPI;

  @Inject('panel-loader-establishment')
  panelEstablishmentLoader: PanelAPI;

  @Inject('panel-loader-details-1')
  panelDetailsLoaderOne: PanelAPI;

  @Inject('panel-loader-details-2')
  panelDetailsLoaderTwo: PanelAPI;

  @Inject('panel-exam-title')
  panelExamTitle: PanelAPI;

  @Inject('panel-exam-left-card')
  panelExamInfo: PanelAPI;

  @Inject('panel-exam-right-card')
  panelEstablishmentInfo: PanelAPI;

  @Inject('panel-loader-report')
  panelReportLoader: PanelAPI;

  @Inject('information-bar')
  informationBar: InformationBarAPI;

  @Inject('card-exams-title-0')
  checkRead: CardExamsTitleAPI;

  @Inject(ExamDetailsAliases.DOWNLOAD_EXAM_BTN)
  downloadButton: ActionAPI;

  @Inject(ExamDetailsAliases.PAC_BTN)
  pacsButton: ActionAPI;

  pacsLinkGeneratorService: PacsLinkGeneratorService = new PacsLinkGeneratorService();

  @OnMount({ target: 'layout-exams-details' })
  onLayoutExamsDetail(): void {
    const event = new CustomEvent('updateModulesRoute', { detail: { moduleId: 'exams' } });
    dispatchEvent(event);
  }

  @OnMount({ target: 'card-exams-title-0' })
  onLoadTitle(): void {
    this.checkRead.onSubmitCheck.listen(() => this.onSubmitCheck())
    const param = this.context.get('reportParams') as Data
    if (param) {
      this.checkRead.setEnabled(param.IE_LIDO == 'S' ? true : false);
    }
  }

  onSubmitCheck(): void {
    const param = this.context.get('reportParams') as Data
    if (param) {
      const params = {
        nrPrescricao: param.NR_PRESCRICAO,
        nrSequencia: param.NR_SEQUENCIA_PROCEDIMENTO,
        examType: param.EXAM_TYPE,
        ie_mark: this.checkRead.getCheckState() ? 'RN' : 'R'
      };
      const body = {
        parameters: params,
      };
      HttpService.post(APPLICATION_ENDPOINTS.POST_MARK_EXAM, {}, { body });
    }
  }

  @OnCollapse({ target: 'information-bar' })
  onClickInformationBar(): void {
    const { informationBar } = this
    if (isMobile()) {
      return;
    }
    informationBar.setCollapsed(false);
  }

  @OnMount({ target: 'layout-content' })
  onFilterMout(event: MountEvent): void {
    if (event) {
      this.panelReportError.setVisible(false);
      this.showDetailsInfo(false);
      this.showEstablishmentInfo(false);
      this.filterListParams();
      this.prepareFetch();
    }

    const { patientId } = this.historyService.getCurrentRouteParams();
    HttpService.get(APPLICATION_ENDPOINTS.GET_DATA_PATIENT, { patientId }).then(response => {
      const dataPerson = response.body as Person;
      this.informationBar.setTitle(dataPerson.nmPessoaFisica);

      this.informationBar.setFieldOneTitle('result.profile.dob');
      this.informationBar.setFieldOneValue(moment(dataPerson.birthDatePessoaFisica).format('DD MMM YYYY'));

      if (!isMobile()) {
        this.informationBar.setCollapsed(false);
      }

      if (dataPerson.ieFotoPermTws == 'S' && dataPerson.imPessoaFisica) {
        this.informationBar.setImage(wrapImageBase64(dataPerson.imPessoaFisica, '/static/assets/icons/avatar-user-gray.svg'));
      } else {
        this.informationBar.setImage('/static/assets/icons/avatar-user-gray.svg');
      }
    });
  }

  @OnMount({ target: ExamDetailsAliases.PAC_BTN })
  onPacsButtonMount(event: MountEvent): void {
    if (event) {
      this.updatePacsVisibility();
    }
  }

  @OnAfterFetch({ target: ['fetch-exam-details'] })
  onAfterExamDetailFetch(event: FetchEvent): void {
    if (event.data) {
      const data = event.data as ExamDetail;
      this.context.set({ nrAcessoDicom: data.nrAcessoDicom })
      this.updatePacsVisibility();
      this.establishmentFetch(data.cdEstabelecimento);
      this.loadReport(data);
      this.showDetailsInfo(true);
    }
  }

  updatePacsVisibility(): void {
    const { examType } = this.historyService.getCurrentRouteQueryParams();
    this.pacsButton?.setEnabled(examType === 'N');
  }

  @OnClick({ target: ['deck-exams'] })
  onCardDeckClick(event: ClickEvent): void {
    if (event && event.value) {
      this.showDetailsInfo(false);
      this.showEstablishmentInfo(false);
      this.pdfViewer.setVisible(false);
      this.loadExamPage(event);
    }
  }

  @OnClick({ target: [ExamDetailsAliases.DOWNLOAD_EXAM_BTN] })
  onDownloadBtnClick(event: ClickEvent): void {
    if (event) {
      this.downloadReport();
    }
  }

  @OnClick({ target: ExamDetailsAliases.PAC_BTN })
  async OnClickPacBtn(): Promise<void> {
    const { patientId } = this.historyService.getCurrentRouteParams();
    const nrAcessoDicom = this.context.get('nrAcessoDicom')
    const reportParams = this.context.get('reportParams') as Data;
    const organizationId = reportParams.CD_ESTABELECIMENTO || '';
    const pacsState = await this.pacsLinkGeneratorService.getPacsState();

    if (!pacsState.enabled) {
      alert(MessageService.translate('patient.no-pacs-available'));
      return;
    }

    this.pacsLinkGeneratorService.openPacsInChrome({
      examId: nrAcessoDicom?.toString() || '',
      patientId: patientId?.toString() ?? '',
      organizationId: organizationId.toString()
    })
  }

  loadExamPage(event: ClickEvent): void {
    const { nrSequencia, nrPrescricao, type, dtProcedimento, cdMedico, patientId } = event.value;
    const {filterFromDate, filterExamType, filterExamStatus, filterExamsRead} = this.historyService.getCurrentRouteQueryParams() as Record<string,string>;
    if (type === 'L') {
      applicationContext.redirect(APPLICATION_ROUTES.EXAM_LAB_DETAILS,{}, {
        searchParams:{
          cdMedico: cdMedico as string,
          dtProcedimento: dtProcedimento as string,
          patientId: patientId as string,
          filterFromDate: filterFromDate,
          filterExamType: filterExamType,
          filterExamStatus: filterExamStatus,
          filterExamsRead: filterExamsRead
        }
      });
    } else {
      applicationContext.redirect(APPLICATION_ROUTES.EXAM_DETAILS, {}, {
        searchParams:{
          nrSequencia: nrSequencia as string,
          nrPrescricao: nrPrescricao as string,
          examType: type as string,
          dtProcedimento: dtProcedimento as string,
          cdMedico: cdMedico as string,
          patientId: patientId as string,
          filterFromDate: filterFromDate,
          filterExamType: filterExamType,
          filterExamStatus: filterExamStatus,
          filterExamsRead: filterExamsRead
        }
      });
      this.fetchExamDetails.setParameters({ patientId, nrSequencia, nrPrescricao, examType: type, dtProcedimento, cdMedico });
      this.fetchExamDetails.setEndpoint(APPLICATION_ENDPOINTS.GET_EXAM_DETAILS);
      this.fetchExamDetails.forceFetch();
    }
  }

  prepareFetch(): void {
    const { dtProcedimento, nrSequencia, nrPrescricao, examType, patientId, cdMedico } = this.historyService.getCurrentRouteQueryParams() as Record<string,string>;
    this.context.set({ patientId, nrSequencia })
    this.fetchExamDetails.setParameters({ patientId, nrSequencia, nrPrescricao, examType, dtProcedimento, cdMedico });
    this.fetchExamDetails.setEndpoint(APPLICATION_ENDPOINTS.GET_EXAM_DETAILS);
    this.fetchExamDetails.forceFetch();
  }

  filterListParams(): void {
    const { filterExamStatus, filterExamType, patientId, filterExamRead } = this.historyService.getCurrentRouteQueryParams() as Record<string,string>;
    let { filterFromDate } = this.historyService.getCurrentRouteQueryParams() as Record<string,string>;
    if (filterFromDate != 'null') {
      filterFromDate = moment(filterFromDate, ISO_DATE_FORMAT).format(ISO_DATE_FORMAT);
      this.filterList.setParameters({ patientId, filterExamStatus, filterExamType, filterFromDate, filterExamRead });
    } else {
      this.filterList.setParameters({ patientId, filterExamStatus, filterExamType, filterExamRead });
    }
    this.filterList.forceFetch();
  }

  establishmentFetch(cdEstabelecimento: string): void {
    this.showEstablishmentInfo(true);
    HttpService.get(APPLICATION_ENDPOINTS.GET_ESTABLISHMENT_EXAM, { establishmentId: cdEstabelecimento }).then(response => {
      const establishment = response.body as Data;
      this.cardEstablishment.setName(establishment.dsRazaoSocial as string);
      this.cardEstablishment.setAddress(establishment.dsEndereco as string);
      this.cardEstablishment.setAddressNumber(establishment.nrEndereco as string);
      this.cardEstablishment.setStateAdress(establishment.dsEstado as string);
      this.cardEstablishment.setCity(establishment.dsMunicipio as string);
      this.cardEstablishment.setLocalidade(establishment.dsBarrio as string);
      this.cardEstablishment.setPostalCode(establishment.cdCep as string);
      this.cardEstablishment.setDdiTelephone(establishment.nrDdiTelefone as string);
      this.cardEstablishment.setDddTelephone(establishment.nrDddTelefone as string);
      this.cardEstablishment.setTelephone(establishment.nrTelefone as string);
      this.cardEstablishment.setEmail(establishment.dsEmail as string);
    }).catch(err => {
      ToastService.showError(err);
      this.showEstablishmentInfo(false);
    });
  }

  downloadReport(): void {
    if (this.pdfViewer.getSrc() != null) {
      const reportService = new ReportService(this);
      reportService.openInNewWindow(this.pdfViewer.getSrc());
    }
  }

  loadReport(data: ExamDetail): void {
    this.panelReportError.setVisible(false);
    if (data.status === 'R' || data.status === 'A') {
      const params = {
        CD_ESTABELECIMENTO: data.cdEstabelecimento,
        EXAM_NAME: data.nmExame,
        EXAM_TYPE: data.type,
        IE_FORMATO: data.ieFormato || 0,
        NR_ACESSO_DICOM: data.nrAcessoDicom || 0,
        NR_PRESCRICAO: data.nrPrescricao,
        NR_SEQ_INTERNOS: data.internSequenceNumber,
        NR_SEQ_PRESCR: data.sequencePrescription,
        NR_SEQUENCIA_P: data.nrSequencia,
        NR_SEQUENCIA_PROCEDIMENTO: data.nrSequenciaProced,
        NR_SEQUENCIAS: data.nrSeqExame,
        IE_LIDO: data.ieLido,
        VL_PARAM_STATUS_EXAME: 35,
      }
      this.context.set({ reportParams: params });
      const reportService = new ReportService(this);
      this.panelReportLoader.setVisible(true);
      reportService.gerarRelatorio(params).then(async file => {
        const response = await HttpService.get(file, { responseType: 'blob' });
        const fileURL = URL.createObjectURL(response.body as Blob);
        this.pdfViewer.setSrc(fileURL);
        if (!isMobile()) {
          this.pdfViewer.setVisible(true);
        }
        this.panelReportLoader.setVisible(false);
      }).catch(() => {
        this.downloadButton.setEnabled(false);
        this.panelReportError.setVisible(true);
        this.pdfViewer.setVisible(false)
        this.panelReportLoader.setVisible(false);
      });
    } else {
      this.pdfViewer.setVisible(false);
      this.panelReportLoader.setVisible(false);
      this.downloadButton.setEnabled(false);
    }
  }

  showDetailsInfo(show: boolean): void {
    this.panelDetailsLoaderOne.setVisible(!show);
    this.panelExamTitle.setVisible(show);
    this.panelDetailsLoaderTwo.setVisible(!show);
    this.panelExamInfo.setVisible(show);
  }

  showEstablishmentInfo(show: boolean): void {
    this.panelEstablishmentLoader.setVisible(!show);
    this.panelEstablishmentInfo.setVisible(show);
  }
}

export default ExamDetails;
